<div fxLayoutAlign.gt-md="space-between center" fxLayout.lt-md="column">
  <h1>Aluno PAADES - SISGRAD</h1>
  <div>
    <mat-form-field appearance="outline">
      <mat-label>Período Letivo</mat-label>
      <mat-select [(value)]="anoSelecionado" (selectionChange)="getData()">
        <mat-option *ngFor="let ano of anos" [value]="ano">
          {{ ano }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</div>

<form [formGroup]="form">
  <mat-form-field appearance="outline" fxFill>
    <mat-icon matSuffix (click)="filtrar()">search</mat-icon>
    <mat-label>Pesquisar por CPF</mat-label>
    <input
      matInput
      formControlName="cpf"
      type="search"
      mask="000.000.000-00"
      [dropSpecialCharacters]="true"
      (keyup)="filtrar()"
      (keydown.enter)="filtrar()"
      #input />
  </mat-form-field>
</form>

<mat-card class="info" *ngIf="lastSearch && data.length === 0">
  <p>Nenhum resultado encontrado para: {{ lastSearch }}</p>
</mat-card>

<pre *ngIf="data.length > 0">{{ data | json }}</pre>
